import { __extends } from "tslib";
import { AssetEvent } from '../events/AssetEvent';
import { AssetBase } from './AssetBase';
import { UUID } from './UUID';
/**
 *
 * @export class away.pool.AbstractionBase
 */
var AbstractionBase = /** @class */ (function (_super) {
    __extends(AbstractionBase, _super);
    function AbstractionBase(asset, pool) {
        var _this = _super.call(this) || this;
        _this._invalid = true;
        _this._asset = asset;
        _this._pool = pool;
        _this._onClearDelegate = function (event) { return _this.onClear(event); };
        _this._onInvalidateDelegate = function (event) { return _this.onInvalidate(event); };
        if (_this._asset) {
            _this._asset.addEventListener(AssetEvent.CLEAR, _this._onClearDelegate);
            _this._asset.addEventListener(AssetEvent.INVALIDATE, _this._onInvalidateDelegate);
        }
        return _this;
    }
    Object.defineProperty(AbstractionBase, "ID_COUNT", {
        get: function () {
            return UUID.Next();
        },
        set: function (v) {
            // nothing
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     */
    AbstractionBase.prototype.onClear = function (event) {
        if (this._asset) {
            this._asset.removeEventListener(AssetEvent.CLEAR, this._onClearDelegate);
            this._asset.removeEventListener(AssetEvent.INVALIDATE, this._onInvalidateDelegate);
        }
        this._asset.clearAbstraction(this._pool);
        this._pool = null;
        this._asset = null;
    };
    /**
     *
     */
    AbstractionBase.prototype.onInvalidate = function (event) {
        this._invalid = true;
    };
    return AbstractionBase;
}(AssetBase));
export { AbstractionBase };
